import { CantileverMaterialData } from "./cantilever-bom"

export async function fetchCantileverMaterials(): Promise<CantileverMaterialData[]> {
  try {
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
    const res = await fetch(`${supabaseUrl}/functions/v1/get-public-data?type=cantilever-materials`)
    if (!res.ok) {
      console.error("Failed to fetch cantilever materials:", res.status)
      return []
    }
    const json = await res.json()
    return (json.data ?? []) as CantileverMaterialData[]
  } catch (err) {
    console.error("Failed to fetch cantilever materials:", err)
    return []
  }
}
